module.exports = __webpack_public_path__ + "static/media/develop_app.9c90fcde.png";